import * as React from 'react'

import { Box, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const WithinRadiusShiftLocation = () => {
  const [open, toggle] = useToggle()

  return (
    <Tooltip.ItemList
      attachment="bottom center"
      targetAttachment="top center"
      open={open}
      toggle={toggle}
    >
      <Tag leftItem="icon" icon="pin" type="transparent">
        {i18n.t('time_tracking.table.body.within_radius')}
      </Tag>
      <Box gap="s8" textAlign="center" background="grey800" alignItems="center">
        <Text.Header3>{i18n.t('time_tracking.table.body.with_radius_tooltip.header')}</Text.Header3>
        <Text.Normal>
          {i18n.t('time_tracking.table.body.with_radius_tooltip.description')}
        </Text.Normal>
      </Box>
    </Tooltip.ItemList>
  )
}

export default WithinRadiusShiftLocation
